import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { trackEvent, scrollToId } from "@/lib/analytics";

const Linkedin = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.34 18.34V9.99H5.67v8.35h2.67zM7 8.82a1.55 1.55 0 1 0 0-3.1 1.55 1.55 0 0 0 0 3.1zm11.34 9.52v-4.6c0-2.45-1.31-3.59-3.06-3.59-1.41 0-2.04.78-2.39 1.32v-1.13h-2.66c.04.75 0 8.35 0 8.35h2.66v-4.66c0-.24.02-.48.09-.65.19-.48.63-.97 1.36-.97.96 0 1.34.73 1.34 1.8v4.48h2.66z"/></svg>
);

export const Footer = () => {
  const goJoin = () => {
    trackEvent("cta_click", { location: "footer", cta: "join_travel_list" });
    scrollToId("lead-capture");
  };

  return (
    <footer data-testid="site-footer" className="bg-ink text-white/80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <p className="font-serif text-2xl font-semibold text-white mb-3">
              KIS Living<span className="text-terracotta">.</span>
            </p>
            <p className="text-sm leading-relaxed text-white/60">
              Beautiful travel, made simple. Curated resort stays, cruises, and group travel
              experiences.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><button data-testid="footer-link-offers" onClick={() => scrollToId("featured")} className="hover:text-terracotta transition-colors">Travel Offers</button></li>
              <li><button data-testid="footer-link-cruises" onClick={() => scrollToId("featured")} className="hover:text-terracotta transition-colors">Cruises</button></li>
              <li><button data-testid="footer-link-group" onClick={() => scrollToId("featured")} className="hover:text-terracotta transition-colors">Group Travel</button></li>
              <li><button data-testid="footer-link-join" onClick={goJoin} className="hover:text-terracotta transition-colors">Join the Travel List</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><span className="text-white/60">KIS Living</span></li>
              <li><span className="text-white/60">KIS Living Vacations</span></li>
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-terracotta transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-terracotta transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-4">Contact</h4>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2"><Mail size={16} /> <a href="mailto:travel@kislivingvacations.com" data-testid="footer-email" className="hover:text-terracotta transition-colors">travel@kislivingvacations.com</a></li>
              <li className="flex items-center gap-2"><Phone size={16} /> <a href="tel:+18335475433" data-testid="footer-phone" className="hover:text-terracotta transition-colors">1.833.547.5433</a></li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="#" data-testid="social-instagram" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-terracotta transition-colors"><Instagram size={18} /></a>
              <a href="#" data-testid="social-facebook" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-terracotta transition-colors"><Facebook size={18} /></a>
              <a href="#" data-testid="social-linkedin" aria-label="LinkedIn" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-terracotta transition-colors"><Linkedin width={18} height={18} /></a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-7 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} KIS Living Vacations. All rights reserved.</p>
          <p>Beautiful travel, made simple.</p>
        </div>
      </div>
    </footer>
  );
};
